import { render, staticRenderFns } from "./ResturantsFilter.vue?vue&type=template&id=25cc048c"
import script from "./ResturantsFilter.vue?vue&type=script&lang=js"
export * from "./ResturantsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports